import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { datasTableRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type DatasTableProps = {
  title: string
  variant: 'size-table' | 'performance-table' | 'design-table'
  table: {
    title: string
    value: string
  }[]
}

const DatasTable = ({ title, table, variant }: DatasTableProps) => {
  return (
    <Motion animation={datasTableRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} className="mb-spacing-md lg:mb-0">
          <Grid>
            <div
              className={cn([
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:grid',
                {
                  'lg:row-span-10 lg:items-end': variant === 'size-table',
                  'lg:row-span-8 lg:row-start-5 lg:items-start':
                    variant === 'performance-table',
                  'lg:row-span-9 lg:items-end': variant === 'design-table'
                }
              ])}
            >
              <div>
                <div className="flex overflow-hidden">
                  <Typography variant="h5" component="h5" data-motion-title>
                    {title}
                  </Typography>
                </div>

                <div
                  className="mb-spacing-sm mt-spacing-xs overflow-hidden lg:mb-spacing-lg lg:mt-spacing-md"
                  data-motion-line-wrapper
                >
                  <hr
                    className="border-dashed border-text-handwritten-light"
                    data-motion-line
                  />
                </div>

                <div className="grid grid-cols-1 gap-spacing-sm lg:grid-cols-3">
                  {table.map((item, index) => (
                    <div
                      key={`table-col-${index}`}
                      className={cn([
                        'col-span-1 lg:w-[24rem]',
                        'flex flex-col space-y-spacing-md'
                      ])}
                    >
                      <div className="flex overflow-hidden">
                        <Typography
                          variant="small"
                          paragraph
                          className="font-bold text-text-primary-light"
                          data-motion-cell-title
                        >
                          {item.title}
                        </Typography>
                      </div>

                      <div className="flex">
                        <Typography
                          variant="regular"
                          paragraph
                          data-motion-cell-value
                        >
                          {item.value}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Grid>
        </Section>
      )}
    </Motion>
  )
}

export default DatasTable
